import React from "react";

import { ClientCoveragesDataTable } from "./";

import { EnumWrapper } from "../../../../../utils/enums";
import { LANGUAGE_CODES } from "../../../../../utils/enums/enums";

const ClientCoveragesPage = () => {
  return (
    <div className="sub-content">
      <EnumWrapper showLoading={false} enum={LANGUAGE_CODES}>
        <ClientCoveragesDataTable />
      </EnumWrapper>
    </div>
  );
};

export default ClientCoveragesPage;



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/client-coverages/ClientCoveragesPage.js